(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-lobby/assets/javascripts/page-lobby.js') >= 0) return;  svs.modules.push('/components/casino-react/page-lobby/assets/javascripts/page-lobby.js');
"use strict";


const {
  useEffect
} = React;
const ErrorPage = svs.components.casino_react.page_error;
const {
  ReactIcon: Icon,
  ReactIconButton: IconButton
} = svs.ui;
const {
  CasinoSectionExplore
} = svs.components.casino_react;
const {
  CasinoSection,
  CasinoSectionScrollable
} = svs.components.casino_react.casinoSection;
const {
  useSearchResults
} = svs.components.casino_react.casinoStore.hooks;
const {
  FilterAndSort
} = svs.components.casino_react.filterAndSort;
const {
  recommendedGamesOnNoSearchResults
} = svs.casino_react.shared.data;
const {
  constants: {
    GridDisplayModes
  }
} = svs.components.casino_react.common;
const {
  useLastSearchedSelector
} = svs.components.casino_react.casinoStore.selectors;
const {
  setMetaTags
} = svs.components.lbUtils.setMetaTags;
const lobbyMetaData = svs.casino_react.shared.data.seo.lobbyMetaData;
const {
  dispatchClearLastSearched
} = svs.components.casino_react.casinoStore.utils.lastSearched;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const empty = () => React.createElement(IconButton, {
  "aria-label": "Rensa senast bes\xF6kta",
  onClick: () => dispatchClearLastSearched(),
  title: "Rensa senast s\xF6kta"
}, React.createElement(Icon, {
  icon: "dustbin",
  size: "200"
}));
const actionButtons = () => React.createElement(FilterAndSort, null);
const PageLobby = () => {
  const {
    games,
    error,
    isLoading,
    isFetching,
    latestSearchQuery,
    totalGamesCount
  } = useSearchResults();
  const lastSearched = useLastSearchedSelector();
  useEffect(() => {
    setMetaTags({
      docTitle: lobbyMetaData.title,
      metaDesc: lobbyMetaData.metaDescription
    });
  }, []);
  if (error) {
    return React.createElement(ErrorPage, null);
  }
  if (latestSearchQuery) {
    return React.createElement(React.Fragment, null, React.createElement(CasinoSection, {
      ActionButtons: actionButtons,
      displayMode: GridDisplayModes.GRID_UNRESTRICTED,
      isLoading: isLoading || isFetching,
      isSearchResult: (games === null || games === void 0 ? void 0 : games.length) === 0,
      isVirtualized: true,
      items: games !== null && games !== void 0 && games.length ? games : [],
      title: games !== null && games !== void 0 && games.length && totalGamesCount ? "".concat(totalGamesCount, " s\xF6kresultat") : '',
      totalGamesCount: totalGamesCount
    }), (games === null || games === void 0 ? void 0 : games.length) === 0 && React.createElement(CasinoSection, {
      displayMode: GridDisplayModes.GRID_RESTRICTED_DOUBLE_ROW,
      items: recommendedGamesOnNoSearchResults || [],
      title: "Andra spelar just nu"
    }));
  }
  return React.createElement(React.Fragment, null, isLoggedIn && React.createElement(CasinoSectionScrollable, {
    ActionButtons: empty,
    items: lastSearched || [],
    title: "Tidigare bes\xF6kta"
  }), React.createElement(CasinoSectionExplore, null));
};
setGlobal('svs.components.casino_react.pageLobby.PageLobby', PageLobby);

 })(window);